type AppEnv = {
  appEnv: string;
  apiBaseUrl: string;
  appPublicOrigin: string;
  lineMiniAppLiffId: string;
  enableMock: boolean;
  reviewDebugEnabled: boolean;
};

export function isProductionAppEnv(appEnv: string): boolean {
  return ["production", "prod"].includes(appEnv.toLowerCase());
}

export function resolveReviewDebugEnabled(appEnv: string, reviewDebugEnabled: boolean): boolean {
  return reviewDebugEnabled && !isProductionAppEnv(appEnv);
}

export function getEnv(): AppEnv {
  const appEnv = import.meta.env.VITE_APP_ENV ?? "development";

  return {
    appEnv,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8080",
    appPublicOrigin: import.meta.env.VITE_APP_PUBLIC_ORIGIN ?? "",
    lineMiniAppLiffId: import.meta.env.VITE_LINE_MINIAPP_LIFF_ID ?? "",
    enableMock: (import.meta.env.VITE_ENABLE_MOCK ?? "false") === "true",
    reviewDebugEnabled: resolveReviewDebugEnabled(
      appEnv,
      (import.meta.env.VITE_REVIEW_DEBUG_ENABLED ?? "false") === "true"
    )
  };
}
